/* eslint-disable import/prefer-default-export */
export const MAX_TOPIC_THEME_SUM = 10
export const VOC_DEFAULT_CELL_HEIGHT = 216
export const INSIGHT_CHART_MIN_WIDTH = 180
